<h1 class="fw-light">Zahlungsmethoden</h1>
<h5 class="text-muted fw-light">{{dashboard.selectedShop.name}}</h5>
<app-list-payment-methods></app-list-payment-methods>
